var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"icon",class:{ 'inline-flex': !_vm.block },style:({
		fontSize: _vm.showSize ? _vm.showSize : 'unset',
		color: _vm.color ? _vm.color : 'unset',
	}),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":`#${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }